import React, { useContext, useEffect, useState } from "react";
import {
  Col,
  Row,
  Form,
  Input,
  message,
  Select,
  Button,
  DatePicker,
  Modal,
  Radio // Added Radio component
} from "antd";
import { Image } from "antd";
import {
  UploadOutlined, ArrowLeftOutlined, FileOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  EyeOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { UploadFile } from "antd/lib/upload";
import Upload, { RcFile, UploadChangeParam } from "antd/es/upload";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import { FaUpload } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { getDeveloperByID, updateDeveloper, fetchDesignations, deleteDocumentImage, getAllrole } from "../../utils/API";
import dayjs from 'dayjs';

interface DeveloperFormValues {
  employeeId: string;
  roleId: string;
  username: string;
  email: string;
  pemail?: string;
  mobileNo: string;
  designation: string;
  city: string;
  dob?: string;
  employmentType?: number; // Added employment type field
  joining_date?: string;
  exit_date?: string;
  country: string;
  state: string;
  address: string;
  pincode: string;
  leaveBalance?: number;
  order?: number;
  isActive?: boolean;
  isDeleted?: boolean;
}

interface DocumentItem {
  file: File | Blob | string;
  name: string;
  isNew?: boolean;
  id?: string;
}

interface EditDeveloperModalProps {
  visible: boolean;
  taskId?: string;
  onCancel?: any;
  onSuccess?: () => void;
}
interface Designation {
  _id: string;
  name: string;
}
const EditDeveloperModal: React.FC<EditDeveloperModalProps> = (props) => {
  const navigate = useNavigate();
  const { Option } = Select;
  const { visible, onCancel, taskId, onSuccess } = props;
  const { id } = useParams();
  const { authData } = useContext(AuthContext);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const [country, setCountry] = useState([]);
  type DocumentType = string | RcFile;
  const [documents, setDocuments] = useState<DocumentType[]>([]);
  // const [documents, setDocuments] = useState<Array<string | File>>([]);
  const [state, setState] = useState([]);
  // const [documents, setDocuments] = useState<Array<string | File>>([]);
  const [isSaving, setIsSaving] = useState(false);
  const [photo, setPhoto] = useState<File | null>(null);
  const [showAdminContact, setShowAdminContact] = useState(false);
  const [developer, setDeveloper] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [designations, setDesignations] = useState<any>([]);
  const [roles, setRoles] = useState<any>([]);
  const IMAGEURL = process.env.REACT_APP_IMAGE_URL + "/developers/";
  const roleId = authData.roleId;


  const fetchDeveloper = async () => {
  setLoading(true);
  try {
    // Wait for both developer data and roles to be loaded
    const [developerData, rolesData] = await Promise.all([
      getDeveloperByID(taskId || id),
      getAllrole()
    ]);

    setDeveloper(developerData);
    setRoles(rolesData);

    form.setFieldsValue({
      ...developerData,
      dob: parseDOB(developerData.dob),
      joining_date: parseDOB(developerData.joining_date),
      exit_date: parseDOB(developerData.exit_date),
      designation: developerData.designation?._id,
      roleId: developerData.roleId?._id || developerData.roleId,
      employmentType: developerData.employmentType !== undefined && developerData.employmentType !== null 
        ? developerData.employmentType 
        : 1, // Default to 1 (Employee) if not set, but it should be required
    });

    if (developerData.photo) {
      setPreviewImage(`${IMAGEURL}${developerData.photo}`);
    }

    if (developerData.document) {
      setDocuments(developerData.document.filter((doc: any) => typeof doc === 'string'));
    }
  } catch (error) {
    message.error("Failed to fetch developer data.");
  } finally {
    setLoading(false);
  }
};
  const parseDOB = (dob: any) => {
    if (!dob) return null;

    // Try parsing as DD-MM-YYYY first
    const parsed = dayjs(dob, 'DD-MM-YYYY', true);
    if (parsed.isValid()) {
      return parsed;
    }

    // Fallback to default Date parsing
    const fallback = dayjs(new Date(dob));
    return fallback.isValid() ? fallback : null;
  };


  useEffect(() => {
    if (visible && taskId) {
      fetchDeveloper();
    }
  }, [visible, taskId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/uploads/country.json");
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        const data = await response.json();
        setCountry(data); // Ensure data is set correctly
      } catch (error) {
        // console.error("Error fetching country data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/uploads/States.json");
        if (!response.ok) {
          throw new Error("Failed to fetch");
        }
        const data = await response.json();
        setState(data); // Ensure data is set correctly
      } catch (error) {
        // console.error("Error fetching country data:", error);
      }
    };

    fetchData();
  }, []);

  const getBase64 = (file: File | Blob) =>
    new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });



  const imageProps = {
    name: 'image',
    multiple: false, // Only allow single file upload
    beforeUpload(file: any) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        message.error('You can only upload image files!');
      }
      const isLt64M = file.size / 1024 / 1024 < 64;
      if (!isLt64M) {
        message.error('Image must be smaller than 64MB!');
      }
      return isImage && isLt64M;
    },
    onChange(info: any) {
      const newFileList = [...info.fileList];
      if (newFileList.length > 0) {
        const file = newFileList[0];
        if (!file.url && !file.preview) {
          getBase64(file.originFileObj).then((preview) => {
            file.preview = preview;
            setPreviewImage(preview);
            setPhoto(file.originFileObj); // Set the photo state with the selected file
          });
        } else {
          setPreviewImage(file.url || file.preview || '');
          setPhoto(file.originFileObj); // Set the photo state with the selected file
        }
      } else {
        setPreviewImage('');
        setPhoto(null); // Reset the photo state if no file is selected
      }
      setFileList(newFileList.slice(-1)); // Only keep the last uploaded file
    },
    fileList,
  };
  const handleSubmit = async (values: DeveloperFormValues) => {
  setIsSaving(true);
  try {
    const formData = new FormData();

    formData.append("id", taskId || (id as string));
    formData.append("employeeId", values.employeeId || developer.employeeId);
    formData.append("roleId", values.roleId || developer.roleId);
    formData.append("username", values.username);
    formData.append("email", values.email);
    formData.append("pemail", values.pemail || "undefined");
    formData.append("mobileNo", values.mobileNo);
    formData.append("designation", values.designation);
    formData.append("city", values.city);
    formData.append("dob", values.dob ? dayjs(values.dob).format('YYYY-MM-DD') : '');
    
    // Important: Ensure employmentType is sent as number
    const employmentTypeValue = values.employmentType !== undefined && values.employmentType !== null 
      ? values.employmentType 
      : (developer?.employmentType ?? 1);
    formData.append("employmentType", String(employmentTypeValue));
    console.log("Sending employmentType:", employmentTypeValue); // Debug log
    
    formData.append("joining_date", values.joining_date ? dayjs(values.joining_date).format('YYYY-MM-DD') : '');
    formData.append("exit_date", values.exit_date ? dayjs(values.exit_date).format('YYYY-MM-DD') : '');
    formData.append("country", values.country);
    formData.append("state", values.state);
    formData.append("address", values.address);
    formData.append("pincode", values.pincode);
    formData.append("leaveBalance", String(values.leaveBalance ?? developer.leaveBalance ?? 0));
    formData.append("order", String(values.order ?? developer.order ?? 0));
    formData.append("isActive", String(values.isActive ?? developer.isActive));
    formData.append("isDeleted", String(values.isDeleted ?? developer.isDeleted));

    if (photo) {
      formData.append("photo", photo, photo.name);
    }

    const documentsToKeep: string[] = [];
    documents.forEach((doc: any, index: number) => {
      if (doc instanceof File) {
        formData.append(`document`, doc, doc.name);
      } else if (typeof doc === 'string') {
        // For existing documents, we need to track which ones to keep
        documentsToKeep.push(doc);
      }
    });
    formData.append("documentsToKeep", JSON.stringify(documentsToKeep));

    // Debug logging
    console.log("Update Form Data Debug:");
    console.log("id:", taskId || id);
    console.log("username:", values.username);
    console.log("email:", values.email);
    console.log("employmentType:", employmentTypeValue);
    console.log("documents to keep:", documentsToKeep);
    console.log("new documents count:", documents.filter(doc => doc instanceof File).length);

    const response = await updateDeveloper(formData);
    message.success("Developer updated successfully!");

    if (onSuccess) {
      onSuccess();
    } else {
      navigate("/developers");
    }
  } catch (error) {
    console.error("Update error:", error);
    message.error("Failed to update developer. Please try again.");
  } finally {
    setIsSaving(false);
  }
};

  const handleDeleteDocument = async (doc: any, index: number) => {
    try {
      // If it's a string (existing document from server)
      if (typeof doc === 'string') {
        const documentPath = doc; // The full path to the document
        const documentName = doc.split('/').pop() || ''; // Extract just the filename

        // Pass the document name to the API
        await deleteDocumentImage(developer._id, documentName);
        message.success('Document deleted successfully');
      }

      // Remove from local state regardless of type
      setDocuments(documents.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting document:', error);
      message.error('Failed to delete document');
    }
  };


  useEffect(() => {
    const getDesignations = async () => {
      try {
        setIsLoading(true);
        const response: any = await fetchDesignations("", 1); // Pass empty search text and page 1

        // Check if response has data property (assuming API returns {data: [...]})
        if (response?.data) {
          setDesignations(response.data);
        } else if (Array.isArray(response)) {
          // If API directly returns array
          setDesignations(response);
        } else {
          message.error("Failed to load designations");
          setDesignations([]);
        }
      } catch (error) {
        console.error("Error fetching designations:", error);
        message.error("Error loading designations");
      } finally {
        setIsLoading(false);
      }
    };

    getDesignations();
  }, []);

  useEffect(() => {
    const getRoles = async () => {
      try {
        const response: any = await getAllrole();
        console.log('Roles data:', response); // Debug log
        if (Array.isArray(response)) {
          setRoles(response);
        } else {
          console.error('Unexpected roles data format:', response);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    getRoles();
  }, []);
  const getRoleNameById = (id: string) => {
    const match = roles.find((role: any) => role._id === id);
    return match ? match.name : "Unknown Role";
  };

  return (
    <Modal
      key={taskId || id}
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={700}
      centered={false} // Disable centered to use top positioning
      destroyOnClose
      className="custom-modal"
      bodyStyle={{
        overflowY: "auto",
        fontFamily: "inter, sans-serif",
      }}
      style={{
        bottom: 20,
        top: 20,
        // maxHeight: 'calc(100vh - 30px)',
        margin: '0 auto',
        position: 'relative',
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Edit Developer
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        layout="horizontal"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 19 }}
        colon={false}
        style={{ margin: 0 }}
      >


        <div className="elements">
          {/* Profile image */}
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            className="w-full"
          >
            <div className="flex justify-center ">
              <div className="relative w-20 h-20">
                <Upload.Dragger
                  {...imageProps}
                  className="w-full h-full rounded-full border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-blue-500 transition-colors bg-gray-50 overflow-hidden"
                  showUploadList={false}
                >
                  {!previewImage ? (
                    <div className="flex flex-col items-center p-1">
                      <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
                        <UploadOutlined className="text-gray-400 text-base" />
                      </div>
                      <span className="text-xs text-gray-400 mt-1">Profile</span>
                    </div>

                  ) : (
                    <img
                      src={previewImage}
                      alt="Uploaded"
                      className="w-full h-full object-cover"
                    />
                  )}
                </Upload.Dragger>

                {previewImage && (
                  <Button
                    type="text"
                    shape="circle"
                    size="small"
                    icon={<MdDeleteOutline size={16} />}
                    className="absolute top-0 right-0 bg-red-500 text-white hover:bg-red-600 shadow-sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      setPreviewImage("");
                      setFileList([]);
                    }}
                  />
                )}
              </div>
            </div>
          </Form.Item>
          {/* Role */}
          <Col xs={24}>
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Role<span className="text-red-500">*</span></span>}
              name="roleId"
              required={false}
              rules={[{ required: true, message: "Role is required" }]}>
              <Select
                size="large"
                className="CustomSelect"
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "13px",
                  fontWeight: "400",
                  width: "100%",
                  lineHeight: "1.6px",
                  borderRadius: "1vw"


                }}
                placeholder={roles.length ? "Select Role" : "Loading roles..."}
                disabled={!roles.length}
                loading={!roles.length}
              >
                {roles.map((role: any) => (
                  <Option key={role._id} value={role._id}>
                    {role.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {/* Designation */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white">
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Designation<span className="text-red-500">*</span></span>}
              required={false}
              name="designation"
              rules={[{ required: true, message: "Please select Designation" }]}
            >
              <Select
                size="large"
                loading={isLoading}
                disabled={roleId === 2}
                className="CustomSelect"
                placeholder={isLoading ? "Loading..." : "Select Designation"}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (String(option?.children) ?? '').toLowerCase().includes(input.toLowerCase())
                }
              >
                {designations.map((item: Designation) => (
                  <Option key={item._id} value={item._id}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          
          {/* Username */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white">
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Username<span className="text-red-500">*</span></span>}
              required={false}
              name="username"
              rules={[
                {
                  required: true,
                  message: "Please Enter Username",
                },
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Username"
              />
            </Form.Item>
          </Col>
          
          {/* Email */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white mb-4">
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Email<span className="text-red-500">*</span></span>}
              required={false}
              name="email"
              rules={[
                {
                  required: true,
                  message: "Please Enter Email",
                },
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                }
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Enter email address"
              />
            </Form.Item>
          </Col>
          
          {/* Personal Email */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24} className="bg-white mb-4">
            <Form.Item
              label={<span style={{
                color: '#4b5563',
                fontFamily: 'inter, sans-serif',
                fontSize: '14px',
                paddingLeft: "15px",
                fontWeight: 500,
              }}>Personal Email<span className="text-red-500">*</span></span>}
              required={false}
              name="pemail"
              rules={[
                {
                  type: 'email',
                  message: 'Please enter a valid email address',
                }
              ]}
            >
              <Input
                size="large"
                disabled={roleId == 2}
                className="Allinput"
                placeholder="Enter personal email address"
              />
            </Form.Item>
          </Col>
          
          {/* Date of Birth */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Dob<span className="text-red-500">*</span></span>}
                  name="dob"
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter DOB",
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Select DOB"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>


          {/* Employment Type Radio Button - Added between DOB and Joining Date */}
<Col xs={24} sm={24} md={24} xl={24} xxl={24}>
  <Row className="bg-white">
    <Col span={24}>
      <Form.Item
        label={<span style={{
          color: '#4b5563',
          fontFamily: 'inter, sans-serif',
          fontSize: '14px',
          paddingLeft: "2px",
          fontWeight: 500,
        }}>Employment Type<span className="text-red-500">*</span></span>}
        name="employmentType"
       required={false}
        rules={[
          {
            required: true,
            message: "Please select employment type",
          },
        ]}
      >
        <Radio.Group>
          <Radio value={1}>Full Time</Radio>
          <Radio value={0}>Trainee</Radio>
        </Radio.Group>
      </Form.Item>
    </Col>
  </Row>
</Col>

          {/* Joining Date */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Joining Date<span className="text-red-500">*</span></span>}
                  name="joining_date"
                  required={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Joining Date",
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Select Joining Date"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Exit Date */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Exit Date</span>}
                  name="exit_date"
                  required={false}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Select Exit Date"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Contact */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Contact<span className="text-red-500">*</span></span>}
                  required={false}
                  name="mobileNo"
                  rules={[
                    { required: true, message: "Please enter mobile number" },
                    { pattern: /^[0-9]{10}$/, message: "Enter a valid 10-digit mobile number" },
                  ]}
                >
                  <Input
                    size="large"
                    type="number"
                    disabled={roleId == 2}
                    className="Allinput"
                    placeholder="Contact"
                  />
                </Form.Item>
                {showAdminContact && (
                  <div style={{ color: 'gray', fontSize: '12px' }}>
                    Please contact administrator
                  </div>
                )}
              </Col>
            </Row>
          </Col>

          {/* Address */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Address<span className="text-red-500">*</span></span>}
                  required={false}
                  name="address"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Address",
                    },
                  ]}
                >
                  <Input.TextArea
                    rows={4}
                    cols={30}
                    size="large"
                    className="Allinputtextarea"
                    placeholder="Address"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Country */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Country<span className="text-red-500">*</span></span>}
                  required={false}
                  name="country"
                  rules={[
                    {
                      required: true,
                      message: "Please Select country",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    className="CustomSelect"
                    placeholder="Select country"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    defaultValue={"India"}
                    filterOption={(input: any, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {country.map((c: any) => (
                      <Option key={c.code} value={c.name} label={c.name}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* States */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>State<span className="text-red-500">*</span></span>}
                  required={false}
                  name="state"
                  rules={[
                    {
                      required: true,
                      message: "Please Select States",
                    },
                  ]}
                >
                  <Select
                    size="large"
                    className="CustomSelect"
                    placeholder="Select States"
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    defaultValue={"Gujarat"}
                    filterOption={(input: any, option: any) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {state.map((c: any) => (
                      <Option key={c.code} value={c.name} label={c.name}>
                        {c.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* City */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>City<span className="text-red-500">*</span></span>}
                  required={false}
                  name="city"
                  rules={[
                    {
                      required: true,
                      message: "Please Enter city",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    className="Allinput"
                    placeholder="City"
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Pin Code */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Pin Code<span className="text-red-500">*</span></span>}
                  required={false}
                  name="pincode"
                  rules={[
                    { required: true, message: "Please enter a pincode" },
                    { pattern: /^[0-9]{6}$/, message: "Please enter a valid 6-digit pincode" },
                  ]}
                >
                  <Input
                    size="large"
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    className="Allinput"
                    placeholder="Pin Code"
                    maxLength={6}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Leave Balance */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={<span style={{
                    color: '#4b5563',
                    fontFamily: 'inter, sans-serif',
                    fontSize: '14px',
                    paddingLeft: "15px",
                    fontWeight: 500,
                  }}>Leave Balance<span className="text-red-500">*</span></span>}
                  required={false}
                  name="leaveBalance"
                  rules={[
                    { required: true, message: "Please enter a Leave Balance" },
                  ]}
                >
                  <Input
                    size="large"
                    type="text"
                    inputMode="numeric"
                    className="Allinput"
                    placeholder="Leave Balance"
                    maxLength={6}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>

          {/* Documents */}
          <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
            <Row className="bg-white">
              <Col span={24}>
                <Form.Item
                  label={
                    <span
                      style={{
                        color: "#4b5563",
                        fontFamily: "inter, sans-serif",
                        fontSize: "14px",
                        paddingLeft: "15px",
                        fontWeight: 500,
                      }}
                    >
                      Documents<span className="text-red-500">*</span>
                    </span>
                  }
                  name="document"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e.fileList}
                >
                  <div className="flex items-start">
                    {/* Upload button */}
                    <Upload
                      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                      listType="picture-card"
                      multiple
                      maxCount={10}
                      beforeUpload={() => false}
                      showUploadList={false} // ✅ hide built-in file list
                      onChange={(info) => {
                        const newFiles = info.fileList.map((file) => file.originFileObj);
                        const existingDocs = documents.filter(
                          (doc): doc is string => typeof doc === "string"
                        );
                        setDocuments([...existingDocs, ...(newFiles as DocumentType[])]);
                      }}
                    >
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>

                    {/* Preview area next to button */}
                    <div className="ml-4 flex flex-col w-full">
                      {documents.map((doc, index) => {
                        if (!doc) return null;

                        const fileName =
                          typeof doc === "string"
                            ? doc.split("/").pop() || ""
                            : (doc as RcFile).name;

                        const fileUrl =
                          typeof doc === "string"
                            ? `${IMAGEURL}${doc}`
                            : URL.createObjectURL(doc as RcFile);

                        const extension = fileName.split(".").pop()?.toLowerCase();
                        let icon = <FileOutlined className="text-2xl text-gray-600" />;

                        if (["jpg", "jpeg", "png", "gif"].includes(extension || "")) {
                          icon = <FileImageOutlined className="text-2xl text-blue-500" />;
                        } else if (extension === "pdf") {
                          icon = <FilePdfOutlined className="text-2xl text-red-500" />;
                        } else if (["doc", "docx"].includes(extension || "")) {
                          icon = <FileWordOutlined className="text-2xl text-blue-600" />;
                        } else if (["xls", "xlsx"].includes(extension || "")) {
                          icon = <FileExcelOutlined className="text-2xl text-green-600" />;
                        } else if (["ppt", "pptx"].includes(extension || "")) {
                          icon = <FilePptOutlined className="text-2xl text-orange-500" />;
                        }

                        return (
                          <div
                            key={index}
                            className="relative mb-2 p-2 border rounded-lg flex items-center justify-between cursor-pointer hover:bg-gray-50 transition"
                            onClick={() => window.open(fileUrl, "_blank")}
                          >
                            <div className="flex items-center space-x-2">
                              {icon}
                              <span className="text-sm text-gray-700">{fileName}</span>
                            </div>
                            <a
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteDocument(doc, index);
                              }}
                              className="text-red-500 hover:text-red-700"
                            >
                              <DeleteOutlined />
                            </a>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Col>

        </div>
        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onCancel}
                type="button"
                disabled={isLoading}
              >
                Cancel
              </button>

              <button className="allsubmitebutton w-44"
                type="submit"
                disabled={isSaving}>
                {isSaving ? "Updating..." : "Update"}
              </button>
            </div>
          </Col>
        </Row>

      </Form>
    </Modal>
  );
};

export default EditDeveloperModal;